import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Line = ({ ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    <line
      x1='6.5'
      y1='16.7531'
      x2='16.753'
      y2='6.50001'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </IconBase>
);
